import QueryStatistics from "graphql/queries/QueryStatistics";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchStatistics {

	static log( value ) {
		console.prefix('fetchStatistics', value );
	}

	static fetch( identifiers, { callbackSuccess = null, callbackError = null, callbackStart = null } = {}  ) {
		GraphqlGroupedBuilder.addQuery( 'statistics', QueryStatistics, {
			variables: {
				identifier: identifiers,
			},
			resultPath: [ 'statistics' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}
